import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/group-setup/overview.md?raw';

const GroupSetupOverview: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default GroupSetupOverview;
